<template>
    <svg width="10" height="19" viewBox="0 0 10 19" xmlns="http://www.w3.org/2000/svg">
        <path d="m1.429 1.767 7.266 8.03-7.266 7.97" stroke="#FFF" stroke-width="1.8" fill="none" fill-rule="evenodd" stroke-linecap="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconArrowRight',
};
</script>
